module.exports = __webpack_public_path__ + "img/01.9615f9a7.jpg";